module.exports = __webpack_public_path__ + "static/media/negativeLogo.d9926cbb.svg";